import { ARTICLE_VIEW, SET_ARTICLE } from '../constants';
import store from '../store'

export const updateArticleView = status => store.dispatch({ type: ARTICLE_VIEW, status }) 
export const updateArticle     =  article  => store.dispatch({ type: SET_ARTICLE, article }) 
